(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  // set toggle for burger in the sticky menu
  var oMainHeader = document.querySelector('.cc-header'),
    oTopHeaderBar = document.querySelector('.cc-top-header-bar'),
    oHeaderMainMenu = document.querySelector('.cc-header main-menu'),
    oHeaderPromoStrip = document.querySelector('.cc-promo-strip'),
    oHeaderStickyBurger = document.querySelector('.cc-header .menu-burger'),
    oBody = document.querySelector('body');
  
  function setStickyHeaderToggle() {
    if(oHeaderStickyBurger) {
      oHeaderStickyBurger.addEventListener('click', function() {
        this.classList.toggle('open');
        // oMainHeader.classList.remove('not-active');
        oMainHeader.classList.toggle('active-sticky');
        oTopHeaderBar.classList.toggle('active-sticky');
        oHeaderMainMenu.classList.toggle('active-sticky');
        oHeaderPromoStrip.classList.toggle('active-sticky');
        oBody.classList.toggle('active-sticky');
      });

      document.addEventListener('scroll', function() {
        if((window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop > 150) {
          oMainHeader.classList.add('not-active'); 
          oHeaderStickyBurger.classList.add('active');
          oBody.classList.add('page-scrolled');
        } else {
          oMainHeader.classList.remove('not-active');
          oHeaderStickyBurger.classList.remove('active'); 
          oBody.classList.remove('page-scrolled');
        }
      });
    }
  }

  function setHeaderPromoStripInMenuItems() {
    var content = oHeaderPromoStrip.innerHTML,
        oMegaNavBlocks = oHeaderMainMenu.getElementsByClassName('mega-nav');

    for (let i = 0; i < oMegaNavBlocks.length; i++) {
      oMegaNavBlocks[i].innerHTML += content; 
    } 
  }

  setStickyHeaderToggle();
  setHeaderPromoStripInMenuItems();
  

  } catch(e) { console.error(e); }
})();
})();
